export default __webpack_public_path__ + "static/media/callAgain.aa1c902f.svg";